export const FETCH_PRODUCTOS_REQUEST = "FETCH_PRODUCTOS_REQUEST";
export const FETCH_PRODUCTOS_SUCCESS = "FETCH_PRODUCTOS_SUCCESS";
export const FETCH_PRODUCTOS_FAILURE = "FETCH_PRODUCTOS_FAILURE";
